import React, { useState } from "react";
import { HiOutlineCreditCard } from "react-icons/hi2";
import { CurrentPlan } from "./current-plan";
import { PaymentHistory } from "./payment-history";
import { Panel } from "../../ui";
import { useUser } from "../../hooks";
import { PaymentDetailsModal } from "./payment-details-modal";
import "./billing.scss";

export const Billing = (): JSX.Element => {
  const { currentUser } = useUser();
  const [showPaymentModal, setShowPaymentModal] = useState(false);

  const hasActiveSubscription = currentUser?.has_active_subscription;

  return (
    <div className="billing">
      <Panel
        title="Billing"
        className="billing-panel"
        nodeInTitleRow={
          hasActiveSubscription ? (
            <button
              className="billing-payment-details-btn"
              onClick={() => setShowPaymentModal(true)}
            >
              <HiOutlineCreditCard size={14} />
              Payment Details
            </button>
          ) : null
        }
      >
        <CurrentPlan />
        <PaymentHistory />
      </Panel>
      <PaymentDetailsModal
        open={showPaymentModal}
        onClose={() => setShowPaymentModal(false)}
      />
    </div>
  );
};

export default Billing;
